import React from "react";

export const PaymentHelper = {
    InvoicePaymentStatus: {
        Pending: 0,
        Paid: 1,
        Delayed: 2,
        Canceled: 3,
    },
    InvoicePaymentStatusList: [
        { name: "Pendente", value: 0, color: "primary" },
        { name: "Pago", value: 1, color: "success" },
        { name: "Atrasado", value: 2, color: "danger" },
        { name: "Cancelado", value: 3, color: "warning" },
    ],
    InvoiceTranslate: function (i) {
        const res = this.InvoicePaymentStatusList.filter(x => x.value == i);
        if (res.length > 0) {
            return <span className={`badge badge-${res[0].color}`}>{res[0].name}</span>
        } else {
            return "S.I.";
        }
    }
}